// Selector to get the active subscription data
export const getActiveSubscriptionData = (state) => state.subscription;

